'use strict';

import header from '../components/header';
import footerTray from '../components/footer-tray';
import headerNavigation from '../components/header-navigation';
import headerSearch from '../components/header-search';
import carousel from '../components/carousel';
import productTiles from '../components/product-tile';

import backdropHelper from '../helpers/backdrop';
import imagesHelper from '../helpers/images';
import viewportHelper from '../helpers/viewport';

import simpleToggle from '../behaviors/simple-toggle';
import focusable from '../behaviors/focusable';

import pageSearch from '../pages/search';
import pageError from '../pages/error';

import analytics from '../analytics';
import dialog from '../dialog';
import page from '../page';
import rating from '../rating';
import util from '../util';
import foundation from '../foundation';
import validator from '../validator';
import tls from '../tls';
import video from '../video';
import newsletter from '../newsletter';
import main from '../main';

import '../jquery-ext';
import '../cookieprivacy';

import product from '../pages/product';
import tutorial from '../pages/tutorial';

import storelocator from '../pages/storelocator';
import content from '../pages/content';
import promotionlanding from '../pages/promotionlanding';
import regimenselector from '../pages/regimenselector';
import staticPages from '../components/static-pages';
import module1and2cover from '../components/module1and2cover';
import module3and4cover from '../components/module3and4imgvideotext';
import module9ProductSlider from '../components/module9ProductSlider';
import module15plpcover from '../components/module15plpcoveranimation';
import marketsampling from '../marketsampling';
import slick from '../slick';

var pages = {
    product,
    tutorial,
    storelocator,
    content,
    promotionlanding,
    regimenselector
};
var viewport_width = $(window).width();

$(window).on('resize', function() {
    //update the window size on screen size change.
    viewport_width = $(window).width();
    $('.vertical-carousel-pageDesigner, .horizontal-slider').slick('resize');

    setTimeout(function() {
        touchDeviceClassForCSS();
    }, 100);
});

pages.search = pageSearch;
pages.error = pageError;

function touchDeviceClassForCSS() {
    if(util.isTouchDevice()) {
        $('body').addClass('touch');
    } else {
        $('body').removeClass('touch');
    }
}

function playVideoHandler() {
	var MAIN_VIDEO_SELECTOR = ".main-video";
	var CAROUSEL_VIDEO_SELECTOR = ".modal-video";
	$(document)
		// main video (inline)
		.on("click", MAIN_VIDEO_SELECTOR, function () {
			var $this = $(this);

			var $inlineEle = $this.parent("div"),
				videoId = $this.data("video-id");

			video.playInline($inlineEle, videoId);
		})

		// carousel videos (launched in modal)
		.on("click", CAROUSEL_VIDEO_SELECTOR, function () {
			var videoId = $(this).data("video-id");

			video.playInModal(videoId);
		});
}

window.app = {
    init: () => {
    	window.sgDialog = dialog;
    	window.sgUtil = util;
        const $ = window.jQuery;
        $(document).foundation();
        main.init();

        // Initialize ES6 Modules
        footerTray.init($);
        header.init($);
        headerNavigation.init($);
        headerSearch.init($, Resources.SIMPLE_SEARCH);
        carousel.init($);
        backdropHelper.init($);
        productTiles.init($);
        imagesHelper.initLazyLoaded($);
        imagesHelper.loadProductImages($);
        viewportHelper.listenForPageEvents($);
        newsletter.init();
        newsletter.pdNewsletterComponent();
        newsletter.footerNewsletter();
        playVideoHandler();
        simpleToggle.init($);
        focusable.init($);
        util.updateWithCsrfInputAjax();//add csrf for post ajax call
        touchDeviceClassForCSS();
        staticPages.init();
        module1and2cover.init();
        module3and4cover.init();
        module9ProductSlider.init();
        module15plpcover.init();

        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }

        if($('.pt_pagedesigner_storefront').length > 0) {
            if($('.pd-footer').length > 0) {
                $('<li>', {class: 'recommendation-item pdVerticalSlider-item'}).appendTo('.vertical-carousel-pageDesigner');
                $('.pd-footer').appendTo('.pdVerticalSlider-item:last-child');
            }
            function debounce(func, wait, immediate) {
                var timeout;
                return function() {
                    var context = this, args = arguments;
                    var later = function() {
                        timeout = null;
                        if (!immediate) func.apply(context, args);
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) func.apply(context, args);
                };
            };

            // use x and y mousewheel event data to navigate flickity
            function slick_handle_wheel_event(e, slick_instance, homeHeroCarousel_is_animating) {
                // do not trigger a slide change if another is being animated
                if (!homeHeroCarousel_is_animating) {
                    var direction =
                    Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
                    if (direction > 0) {
                        // next slide
                        slick_instance.slick("slickNext");
                    } else {
                        // Do not trigger a slide change when footer content longer and scroll position is not zero
                        if(util.isInViewport($('.pd-footer'))) {
                            if($('.pd-footer-wrapper').scrollTop() <= 0) {
                                slick_instance.slick("slickPrev");
                            }
                        } else {
                            // prev slide
                            slick_instance.slick("slickPrev");
                        }
                    }
                }
            }

            // debounce the wheel event handling since trackpads can have a lot of inertia
            var slick_handle_wheel_event_debounced = debounce( 
                slick_handle_wheel_event
                , 100, true
            );

            // init slider 
            var displayControls = $('.pdVerticalSlider').data('displayControls');
            const homeHeroCarousel = $(".pt_pagedesigner_storefront .vertical-carousel-pageDesigner");

            homeHeroCarousel.slick({
                dots: displayControls,
                vertical: true,
                infinite: false,
                arrows: false,
                verticalSwiping: true,
                responsive: [
                    {
                       breakpoint: 1024,
                       settings: 'unslick'
                    }
                 ]
            });
            var homeHeroCarousel_is_animating = false;

            homeHeroCarousel.on("afterChange", function(index) {
                homeHeroCarousel_is_animating = false;
            });

            homeHeroCarousel.on("beforeChange", function(index) {
                homeHeroCarousel_is_animating = true;
            });

            homeHeroCarousel.on("wheel", function(e) {
                slick_handle_wheel_event_debounced(e.originalEvent, homeHeroCarousel, homeHeroCarousel_is_animating);  
            });
        } else {
            // For PD Vertical Carousel layout component
            $('.vertical-carousel-pageDesigner').on('init', function() {
                var $that = $(this);
                $('.slick-list.draggable', $that).removeAttr('aria-live');
                $('.slick-dots li', $that).each(function(index) {
                    $(this).find('button').attr('aria-label','Display Slide '+(++index) );

                });
            });
            $('.vertical-carousel-pageDesigner').each(function () {
                var slidesToShow = $(this).parent('.pdVerticalSlider').data('slidesToShow');
                var slidesToScroll = $(this).parent('.pdVerticalSlider').data('slidesToScroll');
                var displayControls = $(this).parent('.pdVerticalSlider').data('displayControls');

                $(this).slick({
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    vertical: true,
                    verticalSwiping: true,
                    adaptiveHeight: true,
                    swipe: true,
                    touchMove: true,
                    draggable: true,
                    responsive: [{
                        breakpoint: 600,
                        settings: {
                            slidesToShow: slidesToShow,
                            slidesToScroll: slidesToScroll,
                            infinite: true,
                            dots: displayControls,
                            vertical: true
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            arrows: false,
                            dots: true
                        }
                    }
                    ]
                })
                .on('setPosition', function (event, slick) {
                    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
                });

                // To handle scrolling of carousel on mouse scroll event
                $(this).on('wheel', (function(e) {
                    e.preventDefault();

                    const delta = Math.sign(e.originalEvent.deltaY);
                    if (delta < 0) {
                        $(this).slick('slickPrev');
                    } else {
                        $(this).slick('slickNext');
                    }
                }));
            });
        }

        $('.vertical-carousel-pageDesigner.slick-vertical').on('afterChange', function() {
            setTimeout(function(){
                $('.vertical-carousel-pageDesigner.slick-vertical .slick-slide').each(function() {
                    if ($(this).hasClass('slick-active')) {
                        $(this).find('.component-figure').attr('tabindex', '0');
                    } else {
                        $(this).find('.component-figure').attr('tabindex', '-1');
                    }
                });
            },100);
        });

        $( window ).on( "load", function() {
            // stories corousel  
            $('.stories-carousel').each(function () {
                $(this).slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    centerMode:true,
                    centerPadding:'20%',
                    focusOnSelect: true,
                    nextArrow: $('.stories-carousel__main').hasClass('dark') ? '<svg class="icon next"><use xlink:href="#icon-sr-white-next"></use></svg>' : '<svg class="icon next"><use xlink:href="#icon-sr-next"></use></svg>',
                    prevArrow: $('.stories-carousel__main').hasClass('dark') ? '<svg class="icon prev"><use xlink:href="#icon-sr-white-previous"></use></svg>' : '<svg class="icon prev"><use xlink:href="#icon-sr-previous"></use></svg>',
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                infinite: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: true,
                                dots: true,
                                centerMode:true,
                                centerPadding:'12%'
                            }
                        }                        
                    ]
                });
                $(this).slick("slickGoTo",0,true);
            });
            
            $('.storyShortDescription p').each(function() {
                var currentText = $(this).text();

                if($(window).width() < 768){
                    var matchText = getName(currentText, 25);
                    var finalText = "";
                    for (var i = 0; i< matchText.length; i++) {
                        if (matchText[i].toString() != null) {
                            finalText = finalText + '<p>' + matchText[i].toString() + '</p>';
                        }
                    }
                    $(this).html(finalText);
                } else {
                    var matchText = getName(currentText, 60);
                    var finalText = "";
                    for (var i = 0; i< matchText.length; i++) {
                        if (matchText[i].toString() != null) {
                            finalText = finalText + '<p>' + matchText[i].toString() + '</p>';
                        }
                    }
                    $(this).html(finalText);
                }
            });
        });

        function getName(name, maxLimit) {
            let currentText = name.trim();
            const matchText = [];

            while (currentText.length > maxLimit) {
                let spaceIndex = currentText.lastIndexOf(" ", maxLimit);

                if (spaceIndex === -1) {
                    // No space found: force split to prevent infinite loop (good for Chinese)
                    spaceIndex = maxLimit;
                }

                const newText = currentText.slice(0, spaceIndex).trim();
                matchText.push(newText);

                // Slice the remaining
                currentText = currentText.slice(spaceIndex).trim();
            }

            if (currentText.length > 0) {
                matchText.push(currentText);
            }

            return matchText;
        }

        // Scroll to top on click of footer logo homepage
        if($('.pt_pagedesigner_storefront').length > 0 && $('.pd-footer a[data-link-label="homepage"]').length > 0) { // If homepage & home link available in footer
            $('.pd-footer a[data-link-label="homepage"]').click(function(e) {
                e.preventDefault();
                if($('.vertical-carousel-pageDesigner').length > 0 && viewport_width >= 1024) { // If there is a verticla carousel
                    $('.vertical-carousel-pageDesigner').slick('slickGoTo', 0);
                } else {
                    $('html, body').animate({ scrollTop: 0}, 'slow');
                }
            });
        }

        // Stop vimeo video onclick of close icon
        var vimeoWrap;
        $('.video-overlay-close').click(function() {
            vimeoWrap = $('#vimeoWrap');
            vimeoWrap.html( vimeoWrap.html() );
         });

         // Toggle Unmute and mute of vimeo video       
        $(document).ready(function () {
            $(".vimeo--videoPlaceholder").each(function (index) {
                var videoContainer = $(this);
                var iframe = videoContainer.find("iframe");
                var player = new Vimeo.Player(iframe);
        
                videoContainer.data("player", player);
                videoContainer.data("isMuted", true); // Default to muted
        
                var isAutoplay = videoContainer.attr("data-autoplay") === "true"; // Read autoplay setting

                // Disable autoplay from pausing when another video plays
                player.setAutopause(false);

                // If autoplay is disabled, add cursor:pointer
                if (!isAutoplay) {
                    videoContainer.css("cursor", "pointer");
                }

                var muteButton = $(".muteButton").eq(index);
        
                if (muteButton.length === 0) {
                    return;
                }
        
                muteButton.on("click", function () {
                    var isMuted = videoContainer.data("isMuted");
                    player.setMuted(!isMuted).then(function () {
                        videoContainer.data("isMuted", !isMuted);
                        muteButton.toggleClass("is-muted is-unmuted");
                        muteButton.attr("aria-label", isMuted ? "Mute" : "Unmute");
                    });
                });
        
                // Play/Pause Logic (Only if autoplay is disabled)
                if (!isAutoplay) {
                    var eventPlayed = 0;
        
                    function toggleVideoPlayPause() {
                        if (eventPlayed === 0) {
                            player.play();
                            eventPlayed = 1;
                        } else {
                            player.pause();
                            eventPlayed = 0;
                        }
                    }

                    videoContainer.on("click", toggleVideoPlayPause);
                    // Trigger play/pause when clicking of overlay `module3-4 and module1-2 cover`
                    $(".scroll-parrallax-effect-wrapper .module3-4-text-cta, .cover__module1and2 .paraAfterScroll").on("click", toggleVideoPlayPause);
                }
            });
        });

        //Remove viemo video iframe for mobile and desktop as per screen size
        function toggleMuteUnmuteElements() {
            const desktopElements = document.querySelectorAll(".vimeo--videoPlaceholder .d-only-desktop");
            const mobileElements = document.querySelectorAll(".vimeo--videoPlaceholder .d-only-mobile");
        
            if (window.innerWidth <= 768) {
                desktopElements.forEach(el => el.remove());
            } else {
                mobileElements.forEach(el => el.remove());
            }
        }

        toggleMuteUnmuteElements();

        /*backToTopHandler();
        Removing back-to-top as per LUB2-993 - Not in design
        */

        // init specific global components
        analytics.init();

        foundation.init();

        validator.init();
        rating.init();
        video.init();
        marketsampling.init();
        newsletter.newsletterHeader();
        newsletter.isNewsletterEnabled();
        newsletter.newsletterPersistentFooter();
        newsletter.newsletterMobile();
        newsletter.signUpEventListener();
        newsletter.signUpFooter();
        newsletter.footerNewsletter();
        newsletter.newsletterPersistentFooterMobile();

        // execute page specific initializations
        $.extend(page, window.pageContext);

        var ns = page.ns;

        if (ns && pages[ns] && pages[ns].init) {
            pages[ns].init($);
        }

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }

    }
};
// expose global app obj for 3rd party integrations
window.app.user = window.User;
window.app.SCemailUrl = window.Urls.SCemailUrl;
window.app.Product = {};
window.app.tagmanager = analytics.tagmanager;
window.app.gtmInternalPromotion = analytics.gtmInternalPromotion;

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = main.addSummaryScrollbar;


// Initialize Application
$(() => { window.app.init(); });


